import { useState } from "react";
import { motion } from "framer-motion";
import { Brand } from "./Logo";
import { useLang, LANGS } from "@/i18n";
import { Menu, X, Globe, Phone } from "lucide-react";
import { trackCall } from "./PhoneHours";

export default function Header({ onCta }) {
  const { t, lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const links = [
    ["#come-funziona", t("nav.how")],
    ["#banche-dati", t("nav.dbs")],
    ["#prezzi", t("nav.pricing")],
    ["#casi", t("nav.cases")],
    ["#perche-noi", t("nav.why")],
    ["#team", t("nav.team")],
    ["#faq", t("nav.faq")],
  ];
  return (
    <header className="glass fixed top-9 inset-x-0 z-50 border-b border-[#E2E8F0]" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="header-brand"><Brand compact /></a>
        <nav className="hidden lg:flex items-center gap-6">
          {links.map(([href, label]) => (
            <a key={href} href={href} data-testid={`nav-${href.slice(1)}`}
              className="text-sm font-medium text-[#1A1A1A] hover:text-[#00AEEF] transition-colors duration-200">
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <div className="relative group">
            <button data-testid="lang-switcher" className="flex items-center gap-1.5 text-xs font-semibold text-[#003087] border border-[#E2E8F0] bg-white rounded-full px-3 py-1.5 hover:border-[#00AEEF] transition-colors duration-200">
              <Globe size={13} className="text-[#00AEEF]" /> {lang.toUpperCase()}
            </button>
            <div className="absolute right-0 top-full mt-2 hidden group-hover:block bg-white border border-[#E2E8F0] rounded-xl overflow-hidden shadow-xl">
              {LANGS.map((l) => (
                <button key={l.code} data-testid={`lang-${l.code}`} onClick={() => setLang(l.code)}
                  className={`block w-full text-left px-4 py-2 text-xs hover:bg-[#E6F6FD] transition-colors duration-150 ${l.code === lang ? "text-[#00AEEF] font-bold" : "text-[#1A1A1A]"}`}>
                  {l.name}
                </button>
              ))}
            </div>
          </div>
          <a data-testid="header-phone-btn" href="tel:+393713142397"
            onClick={() => trackCall("header_phone")}
            className="hidden md:inline-flex items-center gap-2 rounded-full border-2 border-[#00AEEF] text-[#003087] px-4 py-2 text-sm font-bold hover:bg-[#00AEEF] hover:text-white transition-colors duration-200">
            <Phone size={14} /> 371 314 2397
          </a>
          <button data-testid="header-cta" onClick={() => onCta("visure")}
            className="btn-green hidden sm:inline-flex rounded-full px-5 py-2.5 text-sm font-bold">
            {t("mobile.cta")}
          </button>
          <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)} className="lg:hidden text-[#003087] p-2" aria-label="menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <motion.nav initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} className="lg:hidden border-t border-[#E2E8F0] bg-white px-5 py-4 space-y-1 shadow-lg" data-testid="mobile-nav">
          {links.map(([href, label]) => (
            <a key={href} href={href} onClick={() => setOpen(false)} className="block py-2.5 text-[#003087] text-sm font-medium border-b border-[#F1F5F9]">
              {label}
            </a>
          ))}
          <button data-testid="mobile-nav-cta" onClick={() => { setOpen(false); onCta("visure"); }}
            className="btn-green w-full mt-3 rounded-full px-5 py-3 text-sm font-bold">
            {t("mobile.cta")}
          </button>
        </motion.nav>
      )}
    </header>
  );
}
